import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  formatErrors,
  msgTypeMessage,
  msgTypeNote,
  reminders,
  smiles,
  templates,
  UPDATE_CHAT_EDIT_MESSAGE, UPDATE_CHAT_REPLY_MESSAGE, roleTechnicalSpecialist, roleChiefNutritionist,
  msgDirectionAiToUser,
  UPDATE_CHAT_REMOVE_MESSAGE,
  UPDATE_CHAT_AI_CARD_EDIT,
  UPDATE_CHAT_AI_BATCH,
  UPDATE_CHAT_AI_BATCH_CLEAR,
  aiOriginEdited,
  aiReviewApproved,
  aiReviewDeclined,
  aiSelfAnswerComment,
  aiConfidenceLevel,
  newAiUiEnabled
} from "../../../constants";
import {
  chatMessageAddAction,
  chatMessageReadAction,
  chatReminderAction
} from "../../../actions/chatAction";
import {aiCardReviewAction, dichatTypingAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {i_attach, i_bell, i_close, i_edit, i_reply, i_smile} from "../../../icons";
import {InputCheckbox} from "../../../utils/checkbox/InputCheckbox";
import {TextareaChat} from "../../../utils/textarea/TextareaChat";
import {ChatReadyAnswersModal} from "../utils/ChatReadyAnswersModal";
import {foodProductsAction} from "../../../actions/foodProductAction";
import {deleteQuickAnswerAction, getListQuickAnswersAction, getQuickAnswerAddRatingAction} from "../../../actions/quickAnswerAction";

export function ChatAdd({unreadCnt}) {
  const [tab, setTab] = useState('msg');
  const client = useSelector(state => state.chat.client);
  const clientID = useSelector(state => state.chat.clientID);
  const chatID = useSelector(state => state.chat.chatID);
  const edited = useSelector(state => state.chat.edited);
  const replied = useSelector(state => state.chat.replied);
  const [defAddMessage, setDefAddMessage] = useState('');
  const inputRef = useRef();
  const [idReadyAnswer, setIdReadyAnswer] = useState('');
  const [openReadyanswers, setOpenReadyanswers] = useState(false);
  const user = useSelector(state => state.user.profile);

    const handleClickTab= (tab) => {
        setTab(tab)
        
        if(tab === 'readyanswers'){
            setOpenReadyanswers(!openReadyanswers)
        }else{
            setOpenReadyanswers(false)
        }
    }

  useEffect(() => {
    setTab('msg');
  }, [clientID]);

  useEffect(() => {
    if (edited || replied) {
      setTab('msg');
    }
  }, [edited, replied]);

  return <React.Fragment>
  {tab === 'replacement' && client && <ChatReplacementBlock defAddMessage={defAddMessage} inputRef={inputRef} />}
  {tab === 'readyanswers' && client && openReadyanswers && <ChatReadyAnswersBlock defAddMessage={defAddMessage} inputRef={inputRef} setIdReadyAnswer={setIdReadyAnswer} />}
  <div className={"chat-panel" + (tab === 'note' ? " chat-panel--note" : "")}>
    <ul className="chat-panel__list">
      <li className={"chat-panel__item" + (tab === 'msg' ? " chat-panel__item--active" : "")}>
        <button type="button" className="chat-panel__link" onClick={() => handleClickTab('msg')}>Cooбщение</button>
      </li>
      <li className={"chat-panel__item" + (tab === 'note' ? " chat-panel__item--active" : "")}>
        <button type="button" className="chat-panel__link" onClick={() => handleClickTab('note')}>Заметка</button>
      </li>
        <li className={"chat-panel__item" + (tab === 'replacement' ? " chat-panel__item--active" : "")}>
            <button type="button" className="chat-panel__link" onClick={() => handleClickTab('replacement')}>Замены</button>
        </li>
        <li className={"chat-panel__item" + (tab === 'readyanswers' ? " chat-panel__item--active" : "")}>
            <button type="button" className="chat-panel__link" onClick={() => handleClickTab('readyanswers')}>Готовые ответы</button>
        </li>
    </ul>
    {(tab === 'msg' || tab === 'replacement' || tab === 'readyanswers') && client && <ChatAddMessage client={client} chatID={chatID} unreadCnt={unreadCnt} edited={edited} replied={replied} defAddMessage={defAddMessage} setDefAddMessage={setDefAddMessage} inputRef={inputRef} idReadyAnswer={idReadyAnswer} setIdReadyAnswer={setIdReadyAnswer} />}
    {tab === 'note' && client && <ChatAddNote clientID={client.id} chatID={chatID} />}
  </div></React.Fragment>;
};

// Как часто подтверждать набор: подпись живёт на сервере двадцать секунд, и
// одного пропущенного подтверждения не хватает, чтобы она пропала посреди набора
const TYPING_PING_MS = 10000;

export function ChatAddMessage({client, chatID, unreadCnt, edited, replied, defAddMessage, setDefAddMessage, inputRef, idReadyAnswer, setIdReadyAnswer}) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const aiCardEdit = useSelector(state => state.chat.aiCardEdit);
  const aiBatch = useSelector(state => state.chat.aiBatch);
  const aiEditLevel = aiConfidenceLevel(aiBatch) || 'pending';
  const aiPrefilledRef = useRef(false);

  // set the text programmatically and recompute the textarea height (autoHeight listens for input)
  const setInputValue = (value) => {
    if (!inputRef.current) return;
    inputRef.current.value = value;
    inputRef.current.dispatchEvent(new Event('input', {bubbles: true}));
  };

  const handleAiCardCancel = () => {
    setInputValue('');
    dispatch({type: UPDATE_CHAT_AI_CARD_EDIT, data: null});
  };

  const handleSmile = (e) => {
    insertToMessage(e.target.value);
  };

  const handleTemplate = (value) => {
    insertToMessage(value);
  };

  const insertToMessage = (value) => {
    if (inputRef.current.value.length + value.length > 4096) {
      return;
    }
    const current = inputRef.current.value;
    const position = inputRef.current.selectionStart;
    inputRef.current.value = current.substring(0, position) +
      value +
      current.substring(position, current.length);
    inputRef.current.focus();
    inputRef.current.setSelectionRange(position + value.length, position + value.length);
  };

  const handleFocus = () => {
    if (unreadCnt > 0) {
      dispatch(chatMessageReadAction(chatID));
    }
  };

  const handleSave = () => {
    if (loading) {
      return;
    }
    const message = inputRef.current.value.trim();
    if (!message && !file) {
      return;
    }
    // The curator answers while a suggestion is live. Two distinct cases:
    // - entered through "Edit" (aiCardEdit is set): took our text and reworked it, so the
    //   message gets ai_origin=edited and gamma gets approved with the final text;
    // - answered on their own (own text, ready answer, picture): the suggestion was not used,
    //   which is a rejection — gamma gets declined and the message carries no ai_origin, or the
    //   feed would show an "AI answer" badge on a message that has nothing to do with AI.
    // The condition matches the card's render condition (ChatAiCard): without generated_response
    // the curator saw no suggestion at all, and a review for such a batch is garbage in gamma.
    // Behind the new UI flag: in the old UI the batch is driven by the side panel.
    const aiAnswering = newAiUiEnabled() && !edited &&
      !!(aiBatch && aiBatch.generated_response && aiBatch.batch_end);
    // Edit mode alone is not enough: a send with no text left (a file only) means the suggestion
    // was not taken, so it belongs in the decline branch rather than being recorded as an
    // approved edit with an empty final text.
    const aiFromCard = aiAnswering && !!aiCardEdit && !!message;
    const aiOrigin = aiFromCard ? aiOriginEdited : null;
    // Dismiss the card right away instead of waiting for the server: while the send is in
    // flight its "Apply" stays active and would deliver a second answer to the client.
    // The suggestion is restored if the send fails.
    // UPDATE_CHAT_AI_BATCH_CLEAR also wipes aiCardEdit, so it has to be restored together with
    // the batch: otherwise a retry after a failed send is no longer recognised as an edit and
    // gets reported to gamma as a decline.
    const batchForReview = aiAnswering ? aiBatch : null;
    const cardEditForRestore = aiCardEdit;
    if (batchForReview) {
      dispatch({type: UPDATE_CHAT_AI_BATCH_CLEAR, client_id: client.id});
    }
    setLoading(true);
    dispatch(chatMessageAddAction(client.id, chatID, msgTypeMessage, message, file, edited ? edited.id : null, replied ? replied.id : null, false, aiOrigin)).then(() => {
      // The AI part comes first and uses dispatch only: the panel unmounts when the chat is
      // switched, and touching inputRef below would throw before the review is sent.
      if (batchForReview) {
        // The message already reached the client. The batch is not refetched even if the review
        // fails: the original suggestion would come back as a card and be sent as a second message.
        dispatch(aiCardReviewAction(aiFromCard ? {
          client_id: client.id,
          batch_end: batchForReview.batch_end,
          status: aiReviewApproved,
          final_text: message
        } : {
          client_id: client.id,
          batch_end: batchForReview.batch_end,
          status: aiReviewDeclined,
          comment: aiSelfAnswerComment
        })).then((res) => {
          if (!res.success) {
            toast.warn('Ответ отправлен, но оценка AI не записана', {position: toast.POSITION.BOTTOM_RIGHT});
          }
        });
      }
      // Отправили — набор кончился, ждать истечения двадцати секунд незачем
      pingTyping(false);
      setLoading(false);
      setFile(null);
      // via setInputValue rather than a plain assignment: otherwise autoHeight never reruns and
      // the empty field keeps the height a long suggestion stretched it to
      setInputValue('');
      if (edited) {
        const msgToRemove = edited.message_direction === msgDirectionAiToUser ? edited.id : null;
        handleEditCancel();
        if (msgToRemove) {
          dispatch({type: UPDATE_CHAT_REMOVE_MESSAGE, message_id: msgToRemove});
        }
      }
      if (replied) {
        handleReplyCancel();
      }

      setDefAddMessage('')

    }).catch(err => {
      // the send failed — restore the suggestion we dismissed optimistically
      if (batchForReview) {
        dispatch({type: UPDATE_CHAT_AI_BATCH, data: batchForReview, client_id: client.id});
        if (cardEditForRestore) {
          // Mark the field as already prefilled before restoring edit mode, or the prefill effect
          // would overwrite what the curator wrote with the original suggestion.
          aiPrefilledRef.current = true;
          dispatch({type: UPDATE_CHAT_AI_CARD_EDIT, data: cardEditForRestore, client_id: client.id});
        }
      }
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
    
    //console.log("idReadyAnswer: ", idReadyAnswer)
    
    if(idReadyAnswer !== ''){
        dispatch(getQuickAnswerAddRatingAction(idReadyAnswer)).then(() => {
          setIdReadyAnswer('')
        }).catch(err => {
          setLoading(false);
          toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }
  };

  const handleEditCancel = () => {
    dispatch({type: UPDATE_CHAT_EDIT_MESSAGE, message: null});
  };

  const handleReplyCancel = () => {
    dispatch({type: UPDATE_CHAT_REPLY_MESSAGE, message: null});
  };

    const handleChangeInputRef = (e) => {
        const value = e.target.value;
        setDefAddMessage(value);
        // Набор пустого поля набором не считается: чистка текста не должна
        // зажигать «печатает…» у клиентки
        if (value) pingTyping(true);
    }

    // Когда последний раз подтвердили набор: подпись живёт на сервере двадцать
    // секунд, и дёргать ручку на каждую букву незачем
    const typingSentAt = useRef(0);

    const pingTyping = (typing) => {
        // Подпись есть только в приложении — у прочих каналов её некому показать
        if (!client || client.channel_type !== 'O') return;

        const now = Date.now();
        if (typing) {
            if (now - typingSentAt.current < TYPING_PING_MS) return;
            typingSentAt.current = now;
        } else {
            typingSentAt.current = 0;
        }
        // Отказ глотаем: мешать набору из-за украшения нельзя
        dispatch(dichatTypingAction(client.id, chatID, typing)).catch(() => {});
    }

  useEffect(() => {
    if (edited) {
      inputRef.current.value = edited.message;
    } else {
      inputRef.current.value = '';
    }
  }, [edited]);

  // "Edit" on the AI card moves the text into the input. While reply/edit modes are active the
  // field belongs to them, so we prefill as soon as they are cleared: otherwise the suggestion
  // disappears from the UI entirely (the card is already hidden by edit mode).
  // Declared after the effect that resets the field on `edited`, or that one would wipe the text.
  useEffect(() => {
    if (!aiCardEdit || edited || replied) {
      aiPrefilledRef.current = false;
      return;
    }
    if (aiPrefilledRef.current || !inputRef.current) {
      return;
    }
    aiPrefilledRef.current = true;
    setInputValue(aiCardEdit.original_text);
    inputRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiCardEdit, edited, replied]);

  useLayoutEffect(() => {
    inputRef.current.focus();
  }, [client.id]);

  return <div className="chat-panel__content chat-panel__content--active">
    {replied && <div className="chat-panel__edited">
      <div className="chat-panel__edited--icon">
        {i_reply()}
      </div>
      <p className="chat-panel__edited--text">{replied.message}</p>
      <button type="button" className="chat-panel__icon" disabled={loading} onClick={handleReplyCancel}>
        {i_close()}
      </button>
    </div>}
    {edited && <div className="chat-panel__edited">
      <div className="chat-panel__edited--icon">
        {i_edit()}
      </div>
      <p className="chat-panel__edited--text">{edited.message}</p>
      <button type="button" className="chat-panel__icon" disabled={loading} onClick={handleEditCancel}>
        {i_close()}
      </button>
    </div>}
    {aiCardEdit && !edited && !replied && <div className={"chat-panel__edited chat-panel__ai-edit chat-panel__ai-edit--" + aiEditLevel}>
      <div className="chat-panel__edited--icon">
        <svg width="16" height="16"><use xlinkHref="#robot-face"></use></svg>
      </div>
      <p className="chat-panel__edited--text">Редактирование AI-ответа</p>
      <button type="button" className="chat-panel__icon" disabled={loading} onClick={handleAiCardCancel}>
        {i_close()}
      </button>
    </div>}
    <div className="chat-panel__inner">
      <ChatAddFile handleChange={setFile} loading={loading}/>
      <TextareaChat inputRef={inputRef} loading={loading} placeholder="Написать..." handleFocus={handleFocus} handleSubmit={handleSave} handleChange={handleChangeInputRef}/>
      <button type="button" className="chat-panel__icon">
        {i_smile()}
        <ul className="dropdown dropdown--top dropdown--flex">
          {smiles.map((i, k) => <li key={k} className="dropdown__item">
            <input type="button" value={i} className="dropdown__smile" onClick={handleSmile} />
          </li>)}
        </ul>
      </button>
      <ChatReminder chatID={chatID} />
      <button type="button" className="chat-panel__btn btn" disabled={loading} onClick={handleSave}>Отправить</button>
    </div>
    {file !== null && <div className="chat-panel__attached">
      <div className="attached--item"><span className="attached--icon">{i_attach()}</span> {file.name} <span className="attached--close" onClick={() => setFile(null)}>{i_close()}</span></div>
    </div>}
    <div className="template">
      <button type="button" className="template__item" onClick={() => handleTemplate('{real_name}')}>real_name</button>
      {templates.map((i, k) => <button key={k} type="button" className="template__item" onClick={() => handleTemplate(i.replace('[name]', client.first_name))}>{i.replace('[name]', client.first_name)}</button>)}
      <button type="button" className="template__item" onClick={() => handleTemplate('{control}')}>control</button>
    </div>
  </div>;
};

export function ChatAddFile({accept = '.jpg, .jpeg, .png', multiple = false, loading, handleChange}) {
//export function ChatAddFile({accept = '.jpg, .jpeg, .png, .pdf', multiple = false, loading, handleChange}) {
  const [value, setValue] = useState('');
  const refInput = useRef(null);

  const handleFileSelected = (e) => {
    const file = e.target.files && e.target.files.length > 0 ? (multiple ? e.target.files : e.target.files[0]) : null;
    handleChange(file);
    setValue('');
  };

  return <label className="chat-panel__attach">
    {i_attach()}
    <input type="file"
           ref={refInput}
           accept={accept}
           multiple={multiple}
           disabled={loading}
           value={value}
           onChange={handleFileSelected}
    />
  </label>;
}

export function ChatReminder({chatID}) {
  const chatInfo = useSelector(state => state.chat.chatInfo);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    id: chatID,
    postpone: false,
    remind: false,
    time: 0
  });
  const dispatch = useDispatch();

  const handleChange = (field, value) => {
    const changes = {[field]: field === 'time' ? Number(value) : value};
    if (field === 'remind' && !value) {
      changes['time'] = 0;
    }
    setForm({...form, ...changes});
  };

  const handleReset = () => {
    if (loading) {
      return;
    }
    dispatch(chatReminderAction(form)).then(() => {
      setLoading(false);
      toast.success('Сохранено', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleSave = () => {
    if (loading) {
      return;
    }
    let errs = {};
    if (form.remind && !form.time) {
      errs.time = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    dispatch(chatReminderAction(form)).then(() => {
      setLoading(false);
      toast.success('Сохранено', {position: toast.POSITION.BOTTOM_RIGHT});
      setForm({
        id: chatID,
        postpone: false,
        remind: false,
        time: 0
      });
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className={"chat-panel__icon pointer" + (chatInfo && (chatInfo.postpone || chatInfo.remind) ? " active" : "")}>
    {i_bell()}
    <ul className="dropdown dropdown--top">
      {(!chatInfo || (!chatInfo.postpone && !chatInfo.remind)) && <li className="dropdown__item">
        <InputCheckbox title="Ответить позже" name="postpone" checked={form.postpone} onChange={handleChange}/>
        <InputCheckbox title="Напомнить через" name="remind" checked={form.remind} onChange={handleChange}/>
        <select name="time"
                className={"dropdown__select select" + (errors.time ? " select--error" : "")}
                value={form.time}
                disabled={!form.remind || loading}
                onChange={(e) => handleChange('time', e.target.value)}>
          <option value="0">Выберите</option>
          {reminders.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
        </select>
        <button type="button" className="dropdown__btn btn" disabled={loading} onClick={handleSave}>Сохранить</button>
      </li>}
      {chatInfo && (chatInfo.postpone || chatInfo.remind) && <li className="dropdown__item">
        <button type="button" className="dropdown__btn--reset btn" disabled={loading} onClick={handleReset}>Убрать из отложенных</button>
      </li>}
    </ul>
  </div>;
};

export function ChatAddNote({clientID, chatID}) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const inputRef = useRef();

  const handleSave = () => {
    if (loading) {
      return;
    }
    const message = inputRef.current.value.trim();
    if (!message) {
      return;
    }
    setLoading(true);
    dispatch(chatMessageAddAction(clientID, chatID, msgTypeNote, message)).then(() => {
      setLoading(false);
      inputRef.current.value = '';
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useLayoutEffect(() => {
    inputRef.current.focus();
  }, [clientID]);

  return <div className="chat-panel__content chat-panel__content--active">
    <div className="chat-panel__inner">
      <TextareaChat inputRef={inputRef} loading={loading} handleSubmit={handleSave} placeholder="Оставить заметку..."/>
      <button type="button" className="chat-panel__btn btn" disabled={loading} onClick={handleSave}>Сохранить</button>
    </div>
  </div>
};


export function ChatReplacementBlock({defAddMessage, inputRef}) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [openFrom, setOpenFrom] = useState(false);
    const [openTo, setOpenTo] = useState(false);
    const [replacementFrom, setReplacementFrom] = useState([]);
    const [replacementTo, setReplacementTo] = useState([]);
    const [measuredFrom, setMeasuredFrom] = useState('г');
    const [measuredTo, setMeasuredTo] = useState('г');
    const [portionFrom, setPortionFrom] = useState(0);
    const [portionTo, setPortionTo] = useState(0);
    const [replacementFromValue, setReplacementFromValue] = useState('');
    const [replacementToValue, setReplacementToValue] = useState('');
    const [itemReplacementFrom, setItemReplacementFrom] = useState(null);
    const [itemReplacementTo, setItemReplacementTo] = useState(null);
    const [messageOut, setMessageOut] = useState('');

    //let addMessage = document.querySelector('#add_message')

    const handleChangeReplacementFrom = (e) => {
        /*if (loading) {
          return;
        }*/
        
        setOpenTo(false);
        
        const name = e.target.name;
        const value = e.target.value;
        
        setReplacementFromValue(value);
        
        const message = value.trim();
        if (!message) {
          setReplacementToValue('')
          return;
        }
            
        setTimeout(() => {
            setLoading(true);
            dispatch(foodProductsAction({name: message})).then((data) => {
              setLoading(false);
              
              setReplacementFrom(data.items)
              
              if(data.items.length > 0){
                  setOpenFrom(true);
              }else{
                  setOpenFrom(false);
              }
              
            }).catch(err => {
              setLoading(false);
              toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
            });
        }, 500);
    };

  const handleClickReplacementFrom = (item) => {
    if (loading) {
      return;
    }
    
    setReplacementFromValue(item.name)
    setMeasuredFrom(item.measured_str_min)
    setOpenFrom(false);
    setItemReplacementFrom(item);
    
    setLoading(true);
    dispatch(foodProductsAction({category: item.category})).then((data) => {
      setLoading(false);
      
      setReplacementTo(data.items)
      
      if(data.items.length > 0){
          setOpenTo(true);
      }else{
          setOpenTo(false);
      }
      
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

    const handleClickReplacementTo = (item) => {
        if (loading) {
            return;
        }
        
        setReplacementToValue(item.name)
        setMeasuredTo(item.measured_str_min)
        setOpenTo(false);
        setItemReplacementTo(item);
        
        if(itemReplacementFrom !== null){
            let tempKcalFrom = portionFrom*itemReplacementFrom.kcal_in_1_gram
            let tempKcalTo = tempKcalFrom/item.kcal_in_1_gram
            tempKcalTo = Math.round(tempKcalTo)
            
            setPortionTo(tempKcalTo)
            
            let setMessageOutTmp = '{real_name}, вы можете заменить ' + 
                portionFrom + 
                ' ' + 
                measuredStr(portionFrom, itemReplacementFrom.measured) + 
                ' ' + 
                itemReplacementFrom.name_parental + 
                ' на ' + 
                tempKcalTo + 
                ' ' + 
                measuredStr(tempKcalTo, item.measured) + 
                ' ' + 
                item.name_parental
        
            //let addMessage = document.querySelector('#add_message')
            inputRef.current.value = (defAddMessage !== '' ? defAddMessage + '\n':'') + setMessageOutTmp
        }
    };

    const handleChangeReplacementTo = (e) => {
        if (loading) {
            return;
        }

        const name = e.target.name;
        const value = e.target.value;
        
        setReplacementToValue(value);
        
        if(itemReplacementFrom){
            const message = value.trim();
            if (!message) {
              return;
            }
                
            setTimeout(() => {
                setLoading(true);
                dispatch(foodProductsAction({name: message, category: itemReplacementFrom.category})).then((data) => {
                  setLoading(false);
                  
                  setReplacementTo(data.items)
                  
                  if(data.items.length > 0){
                      setOpenTo(true);
                  }else{
                      setOpenTo(false);
                  }
                  
                }).catch(err => {
                  setLoading(false);
                  toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
                });
            }, 500);
        }
    };
    
    const handleChangePortionFrom = (e) => {
        if (loading) {
            return;
        }
        
        const name = e.target.name;
        const value = e.target.value;
        
        setPortionFrom(value);
        
        // вычислить сколько калорий
        
        if(itemReplacementFrom !== null && itemReplacementTo !== null){
            let tempKcalFrom = value*itemReplacementFrom.kcal_in_1_gram
            let tempKcalTo = tempKcalFrom/itemReplacementTo.kcal_in_1_gram
            
            tempKcalTo = Math.round(tempKcalTo)
            
            setPortionTo(tempKcalTo)
        
            let setMessageOutTmp = '{real_name}, вы можете заменить ' + 
                value + 
                ' ' + 
                measuredStr(value, itemReplacementFrom.measured) + 
                ' ' + 
                itemReplacementFrom.name_parental + 
                ' на ' + 
                tempKcalTo + 
                ' ' + 
                measuredStr(tempKcalTo, itemReplacementTo.measured) + 
                ' ' + 
                itemReplacementTo.name_parental
        
            //let addMessage = document.querySelector('#add_message')
            inputRef.current.value = (defAddMessage !== '' ? defAddMessage + '\n':'') + setMessageOutTmp
        }
    };

    const handleChangePortionTo = (e) => {
        if (loading) {
            return;
        }
        
        const name = e.target.name;
        const value = e.target.value;
        
        setPortionTo(value);
        
        if(itemReplacementFrom !== null && itemReplacementTo !== null){
            let tempKcalTo = value*itemReplacementTo.kcal_in_1_gram
            let tempKcalFrom = tempKcalTo/itemReplacementFrom.kcal_in_1_gram
            tempKcalFrom = Math.round(tempKcalFrom)
            
            setPortionFrom(tempKcalFrom)
            
            let setMessageOutTmp = '{real_name}, вы можете заменить ' + 
                tempKcalFrom + 
                ' ' + 
                itemReplacementFrom.measured_str + 
                ' ' + 
                itemReplacementFrom.name_parental + 
                ' на ' + 
                value + 
                ' ' + 
                itemReplacementTo.measured_str + 
                ' ' + 
                itemReplacementTo.name_parental

            //let addMessage = document.querySelector('#add_message')
            inputRef.current.value = (defAddMessage !== '' ? defAddMessage + '\n':'') + setMessageOutTmp
        }
    };
    
    const handleClickReverseReplacement = () => {
        if (loading) {
            return;
        }
        
        let itemReplacementTmp = null

        let nameFrom = itemReplacementFrom.name
        let nameFromParental = itemReplacementFrom.name_parental
        let measured_str_minFrom = itemReplacementFrom.measured_str_min
        let measured_strFrom = itemReplacementFrom.measured_str
        let portionFromTmp = portionFrom
        
        let nameTo = itemReplacementTo.name
        let nameToParental = itemReplacementTo.name_parental
        let measured_str_minTo = itemReplacementTo.measured_str_min
        let measured_strTo = itemReplacementTo.measured_str
        let portionToTmp = portionTo

        itemReplacementTmp = itemReplacementFrom
        
        setItemReplacementFrom(itemReplacementTo)
        setItemReplacementTo(itemReplacementTmp)
        
        setReplacementFromValue(nameTo)
        setMeasuredFrom(measured_str_minTo)
        setPortionFrom(portionToTmp)
        
        setReplacementToValue(nameFrom)
        setMeasuredTo(measured_str_minFrom)
        setPortionTo(portionFromTmp)
        
        let setMessageOutTmp = '{real_name}, вы можете заменить ' + 
            portionToTmp + 
            ' ' + 
            measured_strTo + 
            ' ' + 
            nameToParental + 
            ' на ' + 
            portionFromTmp + 
            ' ' + 
            measured_strFrom + 
            ' ' + 
            nameFromParental

        //let addMessage = document.querySelector('#add_message')
        inputRef.current.value = (defAddMessage !== '' ? defAddMessage + '\n':'') + setMessageOutTmp
    }
    
    const measuredStr = (num, type) => {
        let metr = "";
        
        switch (type) {
            case 1:
                if(num === 1) {
                    metr = "грамм"
                } else if (num > 1 && num < 5) {
                    metr = "грамма"
                } else {
                    metr = "граммов"
                }
                break;
            case 2:
                if(num === 1) {
                    metr = "штука"
                } else if (num > 1 && num < 5) {
                    metr = "штуки"
                } else {
                    metr = "штук"
                }
                break;
            case 3:
                if(num === 1) {
                    metr = "миллилитр"
                } else if (num > 1 && num < 5) {
                    metr = "миллилитра"
                } else {
                    metr = "миллилитров"
                }
                break;
        }
        
        return metr
    }
    
  const handleClickReplacementValueTo = () => {
    if (loading) {
      return;
    }
    
    if(replacementTo.length > 0){
        setOpenTo(true);
    }else{
        setOpenTo(false);
    }
  };
    
  const handleClickReplacementValueFrom = () => {
    if (loading) {
      return;
    }
    
    if(replacementFrom.length > 0){
        setOpenFrom(true);
    }else{
        setOpenFrom(false);
    }
  };
    
  return <div className="replacement-block">
            <div className="replacement-block__body">
                <div className="replacement-block__row">
                    <div className="replacement-block__left">
                        <div className="item-replacement-block">
                            <div className="item-replacement-block__text">
                                <div className={"item-replacement-block__body" + (openFrom ? " open" : "")}>
                                    <div className="item-replacement-block__items">
                                        {replacementFrom && replacementFrom.map((i, k) => {
                                          return <div key={k} className="item-replacement-block__item" onClick={() => handleClickReplacementFrom(i)}>{i.name}</div>;
                                        })}
                                    </div>
                                </div>
                                <input autoComplete="off" name="replacement_from" type="text" placeholder="Введите название продукта" value={replacementFromValue} onChange={handleChangeReplacementFrom} onClick={handleClickReplacementValueFrom}/>
                            </div>
                            <div className="item-replacement-block__number">
                                <input autoComplete="off" type="text" placeholder="120" name="portion_from" value={portionFrom} onChange={handleChangePortionFrom}/>
                                <span>{measuredFrom}</span>
                            </div>
                        </div>
                    </div>
                    <div className="replacement-block__center" onClick={handleClickReverseReplacement}>
                        <div className="replacement-block__img">
                            <img src="/img/replace-img.svg" alt="#" />
                        </div>
                    </div>
                    <div className="replacement-block__rigth">
                        <div className="item-replacement-block">
                            <div className="item-replacement-block__text">
                                <div className={"item-replacement-block__body" + (openTo ? " open" : "")}>
                                    <div className="item-replacement-block__items">
                                        {replacementTo && replacementTo.map((i, k) => {
                                          return <div key={k} className="item-replacement-block__item" onClick={() => handleClickReplacementTo(i)}>{i.name}</div>;
                                        })}
                                    </div>
                                </div>
                                <input autoComplete="off" name="replacement_to" type="text" placeholder="Введите название продукта" value={replacementToValue} onChange={handleChangeReplacementTo} onClick={handleClickReplacementValueTo}/>
                            </div>
                            <div className="item-replacement-block__number">
                                <input autoComplete="off" type="text" placeholder="120"  name="portion_to" value={portionTo} onChange={handleChangePortionTo}/>
                                <span>{measuredTo}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
};

export function ChatReadyAnswersBlock({defAddMessage, inputRef, setIdReadyAnswer}) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [showReadyAnswersBlockResult, setShowReadyAnswersBlockResult] = useState(false);
    const [showrReadyAnswersBlock, setShowrReadyAnswersBlock] = useState(true);
    const [listReadyAnswer, setListReadyAnswer] = useState([]);
    const [filter, setFilter] = useState({
        page: 1,
        limit: 1000,
        sort: 'rating',
        sortd: 'DESC'
    });
    const [filterSearch, setFilterSearch] = useState({
        page: 1,
        limit: 1000,
        sort: 'rating',
        sortd: 'DESC',
        search: '',
        is_search: true
    });
    const [key, setKey] = useState(null);
    const [edit, setEdit] = useState(false);
    const [readyAnswersItems, setReadyAnswersItems] = useState([]);
    const user = useSelector(state => state.user.profile);
    
    const [item, setItem] = useState({
        id: '',
        name: '',
        message: ''
    });
    
    const itemNew = {
        id: '',
        name: '',
        message: ''
    }
    
    const handleTabNavItem = (key, item) => {
        setItem(item)
        setKey(key)
    }
    
    const handleSetEdit = () => {
        setEdit(true)
    }
    
    const handleEditTabNavItem = (item) => {
        if (loading) {
            return;
        }
        
        
    }
    
    const handleDelTabNavItem = (item, isSearch) => {
        if (loading) {
            return;
        }
        
        setLoading(true);
        dispatch(deleteQuickAnswerAction(item.id)).then(() => {
          setLoading(false);
          
          getListQuickAnswers(filter, false)
            if(isSearch){
                getListQuickAnswers(filterSearch, true)
            }
          
        }).catch(err => {
          setLoading(false);
          toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }
    
    const getListQuickAnswers = (filter, isSearch) => {
        setLoading(true);
        dispatch(getListQuickAnswersAction(filter)).then((data) => {
          setLoading(false);
          
          if(isSearch){
              let searchText = filter.search
              let lenSearchText = searchText.length
              
              for(let i in data.items){
                  let tempMessage = data.items[i].message
                  
                  let firstPos = stripos(tempMessage, searchText)
                  
                  let substrText = tempMessage.substr(firstPos, lenSearchText)
                  
                  substrText = '<span>' + substrText + '</span>'
                  
                  // вставить вырезку текста
                  
                  let afterText = tempMessage.slice(0,firstPos)
                  let beforeText = tempMessage.slice(firstPos+lenSearchText)
                  
                  tempMessage = afterText + beforeText
                  
                  let output = [tempMessage.slice(0, firstPos), substrText, tempMessage.slice(firstPos)].join('');
                  
                  data.items[i].message_show = output
              }
              
              setReadyAnswersItems(data.items)
          }else{
            setListReadyAnswer(data.items)
          } 
          
        }).catch(err => {
          setLoading(false);
          toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }
    
    const handleComplete = (isSearch) => {
        getListQuickAnswers(filter, false)
        
        if(isSearch){
            getListQuickAnswers(filterSearch, true)
        }
    }
    
    const handleInsertInInputRef = (item) => {
        setIdReadyAnswer(item.id)
        inputRef.current.value = (defAddMessage !== '' ? defAddMessage + '\n':'') + item.message
    }
    
    const handleChangeSearch = (e) => {
        const value = e.target.value;
        
        const message = value.trim();
        if (!message) {
          setShowReadyAnswersBlockResult(false)
          setShowrReadyAnswersBlock(true)
          return;
        }
        
        setShowReadyAnswersBlockResult(true)
        setShowrReadyAnswersBlock(false)
        
        setTimeout(() => {
            filterSearch.search = message
            
            getListQuickAnswers(filterSearch, true)
        }, 500);
    }
    
    const handleClickSearch = () => {
        
    }
    
    const stripos = (fHaystack, fNeedle, fOffset) => {
        const haystack = (fHaystack + '').toLowerCase()
        const needle = (fNeedle + '').toLowerCase()
        let index = 0
        if ((index = haystack.indexOf(needle, fOffset)) !== -1) {
            return index
        }
        return false
    }
    
    const handleMessageShow = (messageShow) => {
        return {__html: messageShow};
    }
    
    useEffect(() => {
        getListQuickAnswers(filter, false)
    }, [dispatch]);
    
    return 	<div className="ready-answers">
        <div className="ready-answers__body">
            <div className="ready-answers__top">
                <div className="ready-answers__top-row">
                    <div className="ready-answers__top-left">
                        <div className="ready-answers__top-title">
                            Готовые ответы
                        </div>
                    </div>
                    {user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleChiefNutritionist) && <div className="ready-answers__top-right">
                        <div className="ready-answers__top-block">
                            <div className="ready-answers__top-actions">
                                <div className="ready-answers__top-action js-ready-answers-item-edit" onClick={handleSetEdit} >Редактировать</div>
                                {<ChatReadyAnswersModal isEdit={false} handleComplete={() => handleComplete(false)} item={itemNew}/>}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <div className="ready-answers__search">
                <input autoComplete="off" type="text" name="q" placeholder="Поиск" onChange={handleChangeSearch} onClick={handleClickSearch} />
            </div>
            {showrReadyAnswersBlock && <div className="ready-answers__block">
                <div className="ready-answers-tab js-tab">
                    <div className="ready-answers-tab__nav">
                        {listReadyAnswer && listReadyAnswer.map((i, k) => {
                          return <div key={k} className={"ready-answers-tab__nav-item js-tab-nav-item" + (key === k ? " active":"")} data-tab={k} onClick={() => handleTabNavItem(k, i)} onMouseOver={() => handleTabNavItem(k, i)}>{i.name}</div>;
                        })}
                    </div>
                    <div className="ready-answers-tab__body">
                        {listReadyAnswer && listReadyAnswer.map((i, k) => {
                          return <div key={k} className={"ready-answers-tab__body-item js-tab-body-item" + (key === k ? " active":"")} data-tab={k} >
                                <div className={"ready-answers-item js-ready-answers-item" + (edit ? " item-edit":"")}>
                                    <div className="ready-answers-item__text" onClick={() => handleInsertInInputRef(i)}>{i.message}</div>
                                    <div className="ready-answers-item__actions">
                                        {<ChatReadyAnswersModal isEdit={true} handleComplete={() => handleComplete(false)} item={i}/>}
                                        <div className="ready-answers-item__action" onClick={() => handleDelTabNavItem(i, false)}><svg><use xlinkHref="#delete"></use></svg></div>
                                    </div>
                                </div>
                            </div>;
                        })}
                    </div>
                </div>
            </div>}
            {showReadyAnswersBlockResult && <div className="ready-answers__block-result">
                <div className="ready-answers__items">
                    {readyAnswersItems && readyAnswersItems.map((i, k) => {
                        return <div key={k} className="ready-answers__item">
                            <div className={"ready-answers-item js-ready-answers-item" + (edit ? " item-edit":"")}>
                                <div className="ready-answers-item__text" onClick={() => handleInsertInInputRef(i)} dangerouslySetInnerHTML={handleMessageShow(i.message_show)}></div>
                                {user && (user.role_id === roleTechnicalSpecialist || user.role_id === roleChiefNutritionist) && <div className="ready-answers-item__actions">
                                    {<ChatReadyAnswersModal isEdit={true} handleComplete={() => handleComplete(true)} item={i}/>}
                                    <div className="ready-answers-item__action" onClick={() => handleDelTabNavItem(i, true)}><svg><use xlinkHref="#delete"></use></svg></div>
                                </div>}
                            </div>
                        </div>
                    })}
                </div>
            </div>}
        </div>
    </div>;
};
